import { render, staticRenderFns } from "./VersionControl.vue?vue&type=template&id=1213c8af&scoped=true&"
import script from "./VersionControl.vue?vue&type=script&lang=js&"
export * from "./VersionControl.vue?vue&type=script&lang=js&"
import style0 from "./VersionControl.vue?vue&type=style&index=0&id=1213c8af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213c8af",
  null
  
)

export default component.exports